<template>
  <div class="role">

    <el-button type="primary" size="small" class="addBtn" @click="showDialog('add')">新增角色</el-button>
    <el-table :data="list">
      <el-table-column label="编号" prop="id" min-width="60"></el-table-column>

      <el-table-column label="角色名" prop="name" min-width="120"></el-table-column>

      <el-table-column label="用户列表" prop="user_list"></el-table-column>

      <el-table-column label="备注" prop="desc">
        <template slot-scope="scope">
          <p :title="scope.row.desc">{{ scope.row.desc }}</p>
        </template>
      </el-table-column>

      <el-table-column label="操作" min-width="80" fixed="right">
        <template slot-scope="scope">
          <el-button v-if="scope.row.id != 1" type="primary" size="small" class="editBtn"
            @click="showDialog('edit', scope.row.id)">编辑</el-button>
        </template>
      </el-table-column>

    </el-table>

    <!-- 分页 -->
    <el-pagination @current-change="pageChange" :current-page.sync="pager.page" hide-on-single-page
      :page-size="pager.pagesize" prev-text="上一页" next-text="下一页" layout="total, prev, pager, next,jumper"
      :total="pager.count">
    </el-pagination>
    <!-- 新增、修改弹窗 -->
    <el-dialog :title="(oper == 'add' ? '新增' : (oper == 'edit' ? '修改' : '')) + '角色'" :visible.sync="isAlert"
      :close-on-click-modal="false" :close-on-press-escape="false" :before-close="formCancel" class="form-dialog"
      width="600px">
      <el-form :model="formData" :rules="rules" hide-required-asterisk ref="form" label-width="100px">
        <el-form-item label="角色名称" prop="name">
          <el-input v-model.trim="formData.name" :maxlength="20"></el-input>
        </el-form-item>



        <el-form-item label="菜单权限" prop="power">
          <input v-if="formData.id && formData.id == 1" class="all-power" type="text" value="超级管理员,完全权限" disabled>

          <el-tree v-else :data="menus" show-checkbox node-key="id" @check="menuChange"
            :default-checked-keys="defaultChecked" :props="defaultProps" ref="tree" class="menus-tree">
          </el-tree>
        </el-form-item>

        <el-form-item label="备注" prop="desc">
          <el-input v-model.trim="formData.desc" :maxlength="20"></el-input>
        </el-form-item>
      </el-form>
      <div class="dialog-footer">
        <el-button class="cancel-btn" @click="formCancel">取消</el-button>
        <el-button class="submit-btn" @click="formSubmit">提交</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import {
  adminRole,
  adminMenu
} from "@/utils/axios"
import {
  isPhone
} from "@/utils"

import { Base64 } from 'js-base64'

export default {
  name: 'adminRole',
  data () {
    var powerVerify = (rule, value, callback) => {
      if (this.formData.power != '') {
        callback();
      } else {
        callback(new Error('请至少选择一项'));
      }
      callback();
    }
    return {
      mainHeight: (window.innerHeight || document.documentElement.clientHeight || document.body.clientHeight) -
        60, // 容器最小高度(去除header高度)
      isAlert: false,
      oper: '',
      mobiles: '',
      formData: {
        name: '',
        power: '',
        desc: '',
        // mobile: '',
      },
      rules: {
        name: [{
          required: true,
          message: '角色名称不能为空',
          trigger: 'blur'
        }],
        power: [{
          required: true,
          message: '请至少选择一项',
          trigger: 'change'
        },
        {
          validator: powerVerify,
          trigger: 'change'
        }
        ]
      },

      list: [],
      menus: [],
      defaultChecked: [], // 默认选中菜单

      defaultProps: {
        children: 'son',
        label: 'name'
      },

      pager: {
        page: 1,
        pagesize: 12,
        count: 0
      },
      checkedList: [],
    }
  },
  watch: {
    'formData.name': {
      handler (val) {
        if (val) {
          this.formData.name = val.replace(/\s+/g, "")
        }

      },
      deep: true,
      immediate: true
    },
    'formData.desc': {
      handler (val) {
        if (val) {
          this.formData.desc = val.replace(/\s+/g, "")
        }

      },
      deep: true,
      immediate: true
    },
  },
  mounted () {
    this.$nextTick(() => {
      this.getList();
    })
  },
  methods: {
    // 获取列表
    getList () {
      adminRole(this.pager).then(res => {
        if (res.code == 200) {
          let result = JSON.parse(Base64.decode(res.data))
          this.list = result.data;
          this.pager = result.pager;

          // 数值可能为字符串，需转换为number
          for (var key in this.pager) {
            this.pager[key] = parseInt(this.pager[key]);
          }

        } else {
          this.$myAlert({
            type: 'fail',
            title: res.msg
          });
        }
      });
    },

    pageChange (page) {
      this.pager.page = page;
      this.getList();
    },

    // 参数：修改(edit)或添加(add)  id:修改时会有id参数
    showDialog (oper, id) {
      this.oper = oper
      const data = {
        page: 1,
        pagesize: 9999,
      }
      adminMenu(data).then(res => {
        if (res.code == 200) {
          let result = JSON.parse(Base64.decode(res.data))
          this.menus = result.data;
        } else {
          this.$myAlert({
            type: 'fail',
            title: res.msg
          });
        }
      });
      this.defaultChecked = [];
      if (oper == 'add') {
        this.oper = oper;
        if (this.formData.id || this.formData.name) {
          this.formData = {
            name: '',
            power: '',
            desc: '',
            id: '',
            // mobile: '',
          }
          this.mobiles = ''
          this.$refs.form.resetFields(); // 重置表单
          this.defaultChecked = []; // 清空默认选中
        }
        this.isAlert = true;
      } else if (oper == 'edit') {
        adminRole({
          act: 'detail',
          id: id
        }).then(res => {
          if (res.code == 200) {
            const formData = JSON.parse(Base64.decode(res.data))
            let list = []

            this.formData = formData;
            let powerList = formData.power ? formData.power.split(',') : []
            setTimeout(() => {
              this.menus.map((item, index) => {
                powerList.map((power) => {
                  if (item.id == power) {
                    let obj = {
                      id: power,
                      son: item.son
                    }
                    list.push(obj)
                  }
                })
              })
            }, 100)
            setTimeout(() => {
              if (list.length > 0) {
                list.map((son, index) => {
                  list[index].halfList = []
                  list[index].isHalf = false
                  son.son.map((item) => {
                    powerList.map((power) => {
                      if (item.id == power) {
                        list[index].halfList.push(
                          power)
                      }
                    })
                  })
                })
              }
            }, 200)
            setTimeout(() => {
              list.map((item, index) => {
                if (item.son.length != item.halfList.length) {
                  item.isHalf = true
                }
              })
              //处理一级菜单选中和半选中状态
              list.map((item, index) => {
                if (item.isHalf) {
                  powerList.map((power, index2) => {
                    if (power == item.id) {
                      powerList.splice(index2, 1)
                    }
                  })
                }
              })
              this.defaultChecked = powerList;
              this.isAlert = true;
              return list
            }, 300)

          } else {
            this.$myAlert({
              type: 'fail',
              title: res.msg
            });
          }
        });
      }


    },
    menuChange (key, data) {
      let list = data.checkedKeys;
      //将半选中状态的一级菜单 添加入formData
      if (data.halfCheckedKeys.length > 0) {
        list = [...data.halfCheckedKeys, ...list]
      }
      if (data.checkedKeys.length <= 0) {
        this.formData.power = ''
      } else {
        this.formData.power = list.join(',');
      }
      this.$refs.form.validateField("power")
    },
    mobilesVerify () {
      if (this.mobiles.trim() == '') {
        return true
      }
      if (this.formData.id && this.formData.id == 1) {
        let list = [];
        list = this.mobiles.split(',')
        for (let i = 0; i < list.length; i++) {
          if (!isPhone(list[i])) {
            return false
          }
        }
      } else {
        return true
      }
    },

    formCancel () {
      this.isAlert = false;
      this.formData = {
        name: '',
        power: '',
        desc: '',
        id: '',
        // mobile: '',
      }
      this.mobiles = ''
      this.$refs.form.resetFields(); // 重置表单
      this.defaultChecked = []; // 清空默认选中
    },

    formSubmit () {
      if (!this.mobilesVerify()) {
        this.$myAlert({
          type: 'error',
          title: '请输入正确的手机号'
        });
        return
      }
      if (this.formData.id && this.formData.id == 1) {
        this.formData.mobile = this.mobiles
      }
      this.$refs.form.validate(isSuc => {
        if (isSuc) {

          let actV = 'update'
          if (this.oper == 'add') {
            this.formData.id ? delete this.formData.id : '';
            this.formData.mobile ? delete this.formData.mobile : '';
            actV = 'add'
          }
          this.formData.act = actV;


          adminRole(this.formData).then(res => {
            if (res.code == 200) {
              this.isAlert = false;
              this.getList();

              this.$myAlert({
                type: 'success',
                title: (this.oper == 'add' ? '添加' : '修改') + '成功'
              });
            } else {
              this.$myAlert({
                type: 'fail',
                title: res.msg
              });
            }
          });

        }
      });
    },

    remove () {
      this.$myAlert({
        title: '确定删除？',
        callback: () => { // 点击确认触发
        }
      });
    },
  }
}
</script>

<style scoped>
.el-dialog .el-form>>>.el-form-item__label {}

.el-dialog .el-form>>>.el-form-item__content {}

.right-wrap>>>.el-checkbox__input.is-checked+.el-checkbox__label {
  color: #6681FA;
}

.right-wrap>>>.el-checkbox__input.is-checked .el-checkbox__inner,
.el-checkbox__input.is-indeterminate .el-checkbox__inner {
  background-color: #6681FA;
  border-color: #6681FA;
}

.right-wrap>>>.el-switch__core:after {
  background-color: #828DBC;
}

.right-wrap>>>.el-switch.is-checked .el-switch__core::after {
  background-color: #6681FA;
}

.right-wrap>>>.el-input-number__increase {
  display: none;
}

.right-wrap>>>.el-input-number__decrease {
  display: none;
}

.right-wrap .input-number>>>.el-input__inner {
  height: 30px;
  border: none;
  border-bottom: 1px solid #CED4F0;
  border-radius: 0;
  padding: 0;
  margin-left: 10px;
}

.el-table>>>.cell {
  white-space: nowrap;
}
</style>
<style lang="scss" scoped>
.role {
  // display: flex;
  width: 100%;
  height: 100%;
  padding: 28px 24px;


  .menus-tree {
    border: 1px solid #00000014;
    max-height: 320px;
    overflow: auto;
  }

  .el-table {

    .cell {
      white-space: nowrap;
    }
  }

  .left-menus {
    min-width: 170px;
    width: 170px;
    padding: 30px 24px;
    border-right: 1px solid #E5E8F5;
    background-color: #ffffff;

    .add-action {
      display: flex;
      align-items: center;
      cursor: pointer;

      .add-action-img {
        display: flex;
        align-items: center;
        align-items: center;
        width: 24px;
        height: 24px;
        background-color: #6883FB;
        border-radius: 50%;

        &::after {
          content: "+";
          width: 100%;
          font-size: 20px;
          color: #fff;
          text-align: center;
          margin-bottom: 4px;
        }
      }

      .add-action-text {
        font-size: 14px;
        color: #6883FB;
        margin-left: 8px;
      }
    }

    .left-list {
      padding-top: 20px;
    }

    .left-enp-item {
      padding: 12px 0;
      font-size: 15px;
      font-family: PingFangSC-Regular, PingFang SC;
      font-weight: 400;
      color: #525866;
      line-height: 20px;
      cursor: pointer;
    }

    .left-enp-item-active {
      padding: 12px 0;
      font-size: 15px;
      font-family: PingFangSC-Regular, PingFang SC;
      font-weight: 500;
      color: #6883FB;
      line-height: 20px;
    }
  }

  .right-wrap {
    flex: 1;
    padding: 36px 24px;
    overflow: auto;

    .right-temp {
      margin-bottom: 32px;

      .temp-title {
        display: flex;
        align-items: center;
        justify-content: space-between;
        font-size: 18px;
        font-family: PingFangSC-Regular, PingFang SC;
        font-weight: 400;
        color: #293033;
        line-height: 24px;
        padding-bottom: 10px;
        border-bottom: 1px solid #E5E8F5;
      }

      .temp-info {
        margin-top: 12px;
      }
    }

    .submit-btn {
      width: 94px;
      height: 34px;
      font-size: 15px;
      font-family: PingFangSC-Medium, PingFang SC;
      font-weight: 500;
      color: #FFFFFF;
      line-height: 34px;
      background-color: #6883FB;
      border-radius: 17px;
      border: none;
      margin-top: 10px;
    }

    .info-cell {
      margin-bottom: 20px;
    }

    .input-number {
      width: 50px;
    }

    .custom-info {
      position: relative;
      width: 670px;
      padding: 24px;
      border: 1px solid #CED4F0;
      border-radius: 4px;
      margin-top: 10px;

      &::before {
        box-sizing: content-box;
        position: absolute;
        width: 0;
        height: 0;
        top: -16px;
        left: 41px;
        padding: 0;
        border-top: 8px solid transparent;
        border-left: 8px solid transparent;
        border-right: 8px solid transparent;
        border-bottom: 8px solid #fff;
        display: block;
        content: '';
        z-index: 12;
      }

      &::after {
        box-sizing: content-box;
        position: absolute;
        width: 0;
        height: 0;
        top: -18px;
        left: 40px;
        padding: 0;
        border-top: 9px solid transparent;
        border-left: 9px solid transparent;
        border-right: 9px solid transparent;
        border-bottom: 9px solid #CED4F0;
        display: block;
        content: '';
        z-index: 10;
      }
    }

    .custom-group {
      display: flex;
      flex-direction: row;
      flex-wrap: wrap;

      .custom-item {
        display: flex;
        align-items: center;
        justify-content: space-between;
        width: 30%;
        margin-right: 20px;
      }
    }
  }

  .add {
    padding: 8px 12px;
    margin: 24px 0 12px;
    color: #fff;
  }

  .el-table {
    i[class^=el-icon] {
      margin-right: 16px;
      cursor: pointer;
    }
  }

  .el-pagination {
    text-align: center;
    margin-top: 32px;
  }

  .el-dialog {

    .dialog-title {
      font-size: 18px;
      font-family: PingFangSC-Medium, PingFang SC;
      font-weight: 500;
      color: #293033;
      text-align: center;
    }

    .all-power {
      -webkit-appearance: none;
      background-color: #FFF;
      background-image: none;
      border-radius: 4px;
      border: 1px solid #DCDFE6;
      box-sizing: border-box;
      color: #606266;
      display: inline-block;
      font-size: inherit;
      height: 40px;
      line-height: 40px;
      outline: 0;
      padding: 0 15px;
      transition: border-color .2s cubic-bezier(.645, .045, .355, 1);
      width: 100%;
    }

    .dialog-footer {
      display: flex;
      align-items: center;
      justify-content: center;

      .cancel-btn {
        width: 94px;
        height: 34px;
        font-size: 14px;
        font-family: PingFangSC-Medium, PingFang SC;
        font-weight: 500;
        color: #6883FB;
        border: 1px solid #6883FB;
        border-radius: 17px;
        background-color: #fff;
      }

      .submit-btn {
        width: 94px;
        height: 34px;
        font-size: 14px;
        font-family: PingFangSC-Medium, PingFang SC;
        font-weight: 500;
        color: #fff;
        border: none;
        border-radius: 17px;
        background-color: #6883FB;
        margin-left: 16px;
      }

      .el-button {
        padding: 9px 15px;
      }
    }
  }
}


.form-dialog {
  min-width: 600px;
  width: 100vw;
  height: 100vh;
  min-height: 700px;
}

.addChildMenus {
  margin-right: 12px;
  color: #6883FB;
  float: left;
  cursor: pointer;
}
</style>